module.exports = __webpack_public_path__ + "img/bgpic1.a4d41691.png";